import React, { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReviewAddons from "../components/ReviewAddons";
import AdminLayout from "../components/AdminLayout";
import { Context } from "../App";
import { loadBookingFlow } from "../utils/bookingFlowStorage";
import "../adminConsoleTheme.css";

/**
 * Admin quick-book final step: Pay Now (Razorpay) or Save and Pay Later (slot held, pending emails).
 */
export default function AdminPartyBossSlotReviewPage() {
  const navigate = useNavigate();
  const { context } = useContext(Context);
  const draft = loadBookingFlow();

  useEffect(() => {
    if (!context?.isAdminLoggedIn) {
      navigate("/admin", { replace: true });
    }
  }, [context?.isAdminLoggedIn, navigate]);

  useEffect(() => {
    if (
      !draft?.adminBooking ||
      !draft?.slotId ||
      !draft?.eventId ||
      !draft?.personsCount ||
      !draft?.eventDate
    ) {
      navigate("/admin/partyboss-slot-booking", { replace: true });
    }
  }, [draft, navigate]);

  if (
    !draft?.adminBooking ||
    !draft?.slotId ||
    !draft?.eventId ||
    !draft?.personsCount ||
    !draft?.eventDate
  ) {
    return null;
  }

  const selectedValues = {
    eventDate: draft.eventDate,
    eventId: draft.eventId,
    personsCount: draft.personsCount,
    slotId: draft.slotId,
  };

  return (
    <AdminLayout title="PartyBoss slot booking — review">
      <ReviewAddons
        adminBooking
        embed
        isShow
        selectedAddons={draft.selectedAddons || {}}
        totalCost={draft.reviewTotalCost ?? 0}
        selectedValues={selectedValues}
        closeReview={() => navigate("/admin/partyboss-slot-booking/addons")}
        nameOnCake={draft.nameOnCake || ""}
        restoredTheater={draft.selectedTheaterSnapshot}
        restoredSlot={draft.selectedTimeSnapshot}
        bookingName={draft.bookingName}
        whatsapp={draft.whatsapp}
        email={draft.email}
      />
    </AdminLayout>
  );
}
